import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

// Using TomSelect for multi-select dropdowns
// Docs: https://tom-select.js.org/docs/

export default class extends Controller {
    static values = {
        allowEmptyOption: Boolean,
        plugins: Array,
        create: Boolean,
        maxOptions: Number,
        blurOnSelect: Boolean,
        customOption: String,
    }

    connect() {
        const settings = {
            allowEmptyOption: this.allowEmptyOptionValue,
            plugins: this.pluginsValue,
            create: this.createValue,
            createOnBlur: true,
            maxOptions: this.maxOptionsValue || 50,
            // Remove focus after selection
            onItemAdd: () => {
                if (this.blurOnSelectValue) {
                    this.tomSelect.blur()
                }
            }
        }

        this.tomSelect = new TomSelect(this.element, settings)

        // If a special "custom" option is selected, clear and focus to allow free typing
        const customValue = this.hasCustomOptionValue ? this.customOptionValue : '__custom__'
        this.tomSelect.on('change', (val) => {
            // TomSelect passes string for single-select
            if (val === customValue) {
                // Clear without triggering another change that loops
                this.tomSelect.clear(true)
                this.tomSelect.open()
                this.tomSelect.focus()
            }
        })
    }

    disconnect() {
        this.tomSelect?.destroy()
    }
}
